import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { Col, Container, Row } from 'reactstrap';
import { Alignment, EmailInput, Icon, NIPInput, TextArea, TextInput } from 'tacho-ui';
import { Client } from '../../../core/domainModels/clients/Client';
import { defaultUpdateClient, UpdateClient } from '../../../core/domainModels/clients/UpdateClient';
import { ApplicationState } from '../../../state/ApplicationState';
import { fetchClientsThunk, updateClientThunk } from '../../../state/clients/reducer';
import { DispatchType } from '../../../state/configureStore';
import { TachoModal } from '../../components/TachoModal';
import { TachoEditModalTitle } from '../../components/TachoModal/TachoEditTitle';
interface UpdateClientModalProps {
    isOpen: boolean;
    client: Client;
    onToggle: () => void;
}
export const UpdateClientModal = (props: UpdateClientModalProps) => {
    const { formatMessage } = useIntl();
    const dispatch = useDispatch<DispatchType>();
    const [clientData, setClientData] = useState<UpdateClient>(defaultUpdateClient);
    const onSubmit = () => {
        dispatch(updateClientThunk(clientData))
            .unwrap()
            .then(success => {
                if (success) {
                    dispatch(fetchClientsThunk());
                    setClientData(defaultUpdateClient);
                    props.onToggle();
                }
            })
            .catch(err => console.log(err));
    };
    const updateClientPending = useSelector((state: ApplicationState) => state.clients.updateClientPending);
    const updateClientError = useSelector((state: ApplicationState) => state.clients.updateClientError);

    useEffect(() => {
        if (props.client) {
            setClientData({ ...props.client, clientId: props.client.id });
        }
    }, [props.isOpen]);
    return (
        <TachoModal
            size={'lg'}
            height={'auto'}
            isOpen={props.isOpen}
            onToggle={() => {
                setClientData(defaultUpdateClient);
                props.onToggle();
            }}
            onSubmit={onSubmit}
            title={<TachoEditModalTitle titleToTranslation="clientUpdate" icon={Icon.User} />}
            submitLabelToTranslate="commonUpdate"
            submitIcon={Icon.Edit}
            isPending={updateClientPending}
            errorToTranslate={updateClientError}
        >
            <Container fluid className="d-flex flex-column px-4 gap-3">
                <Row>
                    <Col className="d-flex flex-column gap-2">
                        <TextInput
                            labelLength={1}
                            inputLength={3}
                            label={formatMessage({ id: 'clientName' })}
                            value={clientData?.name}
                            onChange={value => setClientData({ ...clientData, name: value })}
                        />

                        <NIPInput
                            labelLength={1}
                            inputLength={3}
                            label={formatMessage({ id: 'clientNip' })}
                            value={clientData?.nip}
                            onChange={value => setClientData({ ...clientData, nip: value })}
                        />

                        <EmailInput
                            labelLength={1}
                            inputLength={3}
                            label={formatMessage({ id: 'clientEmail' })}
                            value={clientData?.email}
                            onChange={value => setClientData({ ...clientData, email: value })}
                        />

                        <TextInput
                            labelLength={1}
                            inputLength={3}
                            label={formatMessage({ id: 'clientPhoneNumber' })}
                            value={clientData?.phoneNumber}
                            onChange={value => setClientData({ ...clientData, phoneNumber: value })}
                        />

                        <TextInput
                            labelLength={1}
                            inputLength={3}
                            label={formatMessage({ id: 'clientCountry' })}
                            value={clientData?.country}
                            onChange={value => setClientData({ ...clientData, country: value })}
                        />
                    </Col>
                    <Col className="d-flex flex-column gap-2">
                        <TextInput
                            labelLength={1}
                            inputLength={3}
                            label={formatMessage({ id: 'clientCity' })}
                            value={clientData?.city}
                            onChange={value => setClientData({ ...clientData, city: value })}
                        />
                        <TextInput
                            labelLength={1}
                            inputLength={3}
                            label={formatMessage({ id: 'clientZipCode' })}
                            value={clientData?.zipCode}
                            onChange={value => setClientData({ ...clientData, zipCode: value })}
                        />
                        <TextInput
                            labelLength={1}
                            inputLength={3}
                            label={formatMessage({ id: 'clientStreet' })}
                            value={clientData?.street}
                            onChange={value => setClientData({ ...clientData, street: value })}
                        />
                        <TextInput
                            labelLength={1}
                            inputLength={3}
                            label={formatMessage({ id: 'clientHouseNumber' })}
                            value={clientData?.houseNumber}
                            onChange={value => setClientData({ ...clientData, houseNumber: value })}
                        />
                        <TextInput
                            labelLength={1}
                            inputLength={3}
                            label={formatMessage({ id: 'clientApartmentNumber' })}
                            value={clientData?.apartamentNumber}
                            onChange={value => setClientData({ ...clientData, apartamentNumber: value })}
                        />
                    </Col>
                </Row>
                <Row>
                    <TextArea
                        labelLength={-1}
                        label={formatMessage({ id: 'clientNotes' })}
                        align={Alignment.flexStart}
                        value={clientData.notes}
                        onChange={value => setClientData({ ...clientData, notes: value as string })}
                    />
                </Row>
            </Container>
        </TachoModal>
    );
};
